const loginUtils = {
  isCanadianUser(countryCode: string, email = ''): boolean {
    const emailParts = email.split('.');
    const topLevelDomain = emailParts[emailParts.length - 1];
    if (countryCode === 'ca' || topLevelDomain === 'ca') {
      return true;
    }
    return false;
  },
};

export default loginUtils;
